module.exports = __webpack_public_path__ + "img/UserPass.a61ab093.svg";